import { render, staticRenderFns } from "./TestItemComplex.vue?vue&type=template&id=18f4357c&scoped=true&"
import script from "./TestItemComplex.vue?vue&type=script&lang=js&"
export * from "./TestItemComplex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f4357c",
  null
  
)

export default component.exports